(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxPrintQueuesHandleNetworks(
    NetworkListPOSTPaging, NetworkListService, $http, $timeout, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printQueuePropertiesMulti/printQueuesHandleNetworks/printQueuesHandleNetworks.template.html',
      link: function(scope) {

        scope.printQueueNetworks = new NetworkListPOSTPaging();
        scope.networkListPaging = new NetworkListPOSTPaging();
        scope.focusMe = false;
        scope.searchString = '';
        scope.otherNetworksTotalPages = 0;
        scope.totalPages = 0;
        scope.selectedNetworks = [];
        scope.unselectedNetworks = [];
        const embed = '&embed=site';
        let scrollEnd = null;
        let containerHeight = null;
        let customKeyBinding = false;
        let mappedNetworks = {
          selectedNetworksOriginal: [],
          addSelectedNetworks: [],
          removeSelectedNetworks: []
        };

        (function() {
          $timeout(function () {
            scope.focusMe = true;
          }, 300)
          customKeyBinding = true;
          initialRequest();
          getFirstPage();
        })();

        function initialRequest () {
          scope.networkListPaging.pagingCriteria.page = 0;
          scope.loadingPage = true;
          scope.networkList = [];

          NetworkListService.getNetworkListPagedByPost(scope.networkListPaging, embed).then(function (response) {
            window.scrollTo(0,0);
            scope.totalElements = response.page.totalElements;
            scope.totalPages = response.page.totalPages;
            scope.networkList = response.list;
            scope.loadingPage = false;
            getPrintQueueNetworks();
          }).catch(function(error) {});
        }

        function getFirstPage() {
          scope.networkListPaging.pagingCriteria.page = 0;
          scope.loadingPage = true;
          scope.networkList = [];

          NetworkListService.getNetworkListPagedByPost(scope.networkListPaging, embed).then(function (response) {
            window.scrollTo(0,0);
            scope.totalElements = response.page.totalElements;
            scope.totalPages = response.page.totalPages;
            scope.networkList = response.list;
            scope.loadingPage = false;
            checkSelectedNetworks();
          }).catch(function(error){});

        }

        scope.textSearch = function () {
          scope.networkListPaging.pagingCriteria.match = scope.searchString;
          getFirstPage();
        }


        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.networkListPaging.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.networkListPaging.pagingCriteria.page += 1;
            NetworkListService.getNetworkListPagedByPost(scope.networkListPaging, embed).then(function(response){
              if (response.list) {
                scope.networkList = scope.networkList.concat(response.list);
              }
              checkSelectedNetworks();
              scope.loadingPage = false;
            }).catch(function(error) {});
          }
        }

        angular.element('.pagination-content').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.networkListPaging.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.pagination-content').off('scroll');
          customKeyBinding = false;
        });

        document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (customKeyBinding){
            switch (evt.keyCode) {
              case 38:
                evt.preventDefault();
                if (document.activeElement.previousElementSibling) {
                  document.activeElement.previousElementSibling.focus();
                }
              break;
              case 40:
                evt.preventDefault();
                if (document.activeElement.nextElementSibling) {
                  document.activeElement.nextElementSibling.focus();
                }
              break;
            }
          }
        };

        scope.toggleSelectItem = function (event, network) {
          event.stopPropagation()
          event.preventDefault()

          if (!network.options.isSelected) {
            network.options.isSelected = true
            scope.selectedNetworks.push(network);
            mappedNetworks.addSelectedNetworks.push(network.info._links.self.href);
            mappedNetworks.removeSelectedNetworks = mappedNetworks.removeSelectedNetworks.filter(selectedNetwork => selectedNetwork !== network.info._links.self.href);
          } else {
            network.options.isSelected = false
            scope.selectedNetworks = scope.selectedNetworks.filter(selectedNetwork => selectedNetwork.info._links.self.href !== network.info._links.self.href);
            mappedNetworks.removeSelectedNetworks.push(network.info._links.self.href);
            mappedNetworks.addSelectedNetworks = mappedNetworks.addSelectedNetworks.filter(selectedNetwork => selectedNetwork !== network.info._links.self.href);

          }

          checkSelectedNetworks();
        }

        scope.saveChanges = function () {
          $rootScope.$broadcast('MULTI_EDIT_NETWORKS_ON_PRINTQUEUES', {mappedNetworks: mappedNetworks});
          scope.callback();
        }

        scope.closePopup = function () {
          scope.callback();
        }

        function mapReleaseFromOtherNetworks () {

          const currentNetworks = scope.context.printQueues.flatMap((queue) => {
            const releaseFromOtherNetwork = queue.info._links['px:releaseFromOtherNetwork'];
            if (releaseFromOtherNetwork) {
              if (Array.isArray(releaseFromOtherNetwork)) {
                return releaseFromOtherNetwork.map(network => network.href)
              } else if  (!Array.isArray(releaseFromOtherNetwork)) {
                return releaseFromOtherNetwork.href;
              }
            }
          }).reduce(
            (unique, item) => (unique.includes(item) ? unique : [...unique, item]),
            [],
          ).filter(function (element) {
            return element != null;
          });

          return currentNetworks;
        }

        function getPrintQueueNetworks () {
          if (mapReleaseFromOtherNetworks().length > 0) {
            scope.printQueueNetworks.pagingCriteria.networkIds = mapReleaseFromOtherNetworks();
            scope.printQueueNetworks.pagingCriteria.pageSize = mapReleaseFromOtherNetworks().length;
            scope.loadingPage = true;
            NetworkListService.getNetworkListPagedByPost(scope.printQueueNetworks, embed).then(function(response) {
              scope.selectedNetworks = response.list;
              mapNetworksForSaving(response.list);
              checkSelectedNetworks();
            }).catch(function(error) {});
          }
        }

        function mapNetworksForSaving () {
          mappedNetworks.selectedNetworksOriginal = scope.selectedNetworks.map(network => network.info._links.self.href);
          mappedNetworks.addSelectedNetworks = scope.selectedNetworks.map(network => network.info._links.self.href);
        }

        function checkSelectedNetworks() {
          scope.networkList.forEach(network => network.options.isSelected = false);
          scope.selectedNetworks.forEach((selectedNetwork) => {
            selectedNetwork.options.isSelected = true;
            scope.networkList.find((network) => {
              if (network.info._links.self.href === selectedNetwork.info._links.self.href) {
                return network.options.isSelected = true;
              }
            })
          })
        }


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          let offsetLeft  =  angular.element('.context-content-container')[0].offsetLeft;
          let offsetTop  =  angular.element('.context-content-container')[0].offsetTop;
          if (showTip) {
            position.startX = position.startX - offsetLeft;
            position.startY = position.startY - offsetTop;
            switch(tooltipScope) {
              case 'networkTooltip':
                networkTooltip(position, context);
              break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function networkTooltip (position, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: context.info.name,
            type: 'networkAllDetails',
            network: context,
          }
          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: true
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }


      }
    };
  }

  pxPrintQueuesHandleNetworks.$inject = [
    'NetworkListPOSTPaging', 'NetworkListService', '$http', '$timeout', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxPrintQueuesHandleNetworks', pxPrintQueuesHandleNetworks);

})();
